module.exports = __webpack_public_path__ + "static/media/comision-personalizada.a395457c.svg";